export default __webpack_public_path__ + "static/media/arrowLeft.076416f9.svg";